import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site-data";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.07, ease: [0.2, 0.8, 0.2, 1] },
  }),
};

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-12">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            variants={fadeUp}
            className="md:col-span-7"
          >
            <div className="text-xs tracking-[0.28em] uppercase font-bold text-[#2E5C3E] mb-4">
              Reviews
            </div>
            <h2 className="font-['Outfit'] text-4xl md:text-6xl font-black tracking-tighter text-[#1A2E20] leading-[1.02]">
              Tallahassee neighbors who said yes.
            </h2>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            variants={fadeUp}
            custom={1}
            className="md:col-span-5 flex md:justify-end"
          >
            <div className="inline-flex items-center gap-3 bg-[#EEF2EF] rounded-2xl px-5 py-3 border border-[#D1DED5]">
              <div className="flex items-center gap-1">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-[#EAB308] text-[#EAB308]"
                  />
                ))}
              </div>
              <span className="text-sm font-bold text-[#1A2E20]">
                4.9 avg from local clients
              </span>
            </div>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              variants={fadeUp}
              custom={i}
              className={`relative rounded-3xl p-7 lift-on-hover border ${
                i % 2 === 0
                  ? "bg-white border-[#D1DED5]"
                  : "bg-[#1A2E20] border-[#1A2E20] text-white"
              }`}
            >
              <Quote
                className={`w-8 h-8 mb-5 ${
                  i % 2 === 0 ? "text-[#EAB308]" : "text-[#EAB308]"
                }`}
                strokeWidth={2.2}
              />
              <blockquote
                className={`font-['Outfit'] text-lg leading-snug font-medium ${
                  i % 2 === 0 ? "text-[#1A2E20]" : "text-white"
                }`}
              >
                "{t.quote}"
              </blockquote>
              <figcaption
                className={`mt-6 pt-5 border-t ${
                  i % 2 === 0 ? "border-[#D1DED5]" : "border-white/15"
                }`}
              >
                <div
                  className={`text-sm font-bold ${
                    i % 2 === 0 ? "text-[#1A2E20]" : "text-white"
                  }`}
                >
                  {t.name}
                </div>
                <div
                  className={`text-xs mt-0.5 ${
                    i % 2 === 0 ? "text-[#4A6E55]" : "text-white/65"
                  }`}
                >
                  {t.location}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
